import 'intro.js/introjs.css'
import 'src/styles/index.css'
import 'src/styles/global-while-migrating-to-design-system.scss'
import type { Component } from 'vue'
import Vue from 'vue'
import VueIframe from 'vue-iframes'

import { useCurrentUser } from '@shared/stores/current-user'
import { globalStoreForLogging } from 'src/App.utils'
import { isDevelopment } from 'src/tpbp-core/utils/common.utils'
import hoverZIndexDirective from './directives/hoverZIndex.directive'
import { setupRaygun } from './plugin'
import { ALL_ROUTES } from './router/all-routes'
import { addRoutes } from './router/index'
import { initNewRelic } from './services/NewRelic.service'
import { requestService } from './services/request.service'
import { useGlobalState } from './store/globalStore'
import { logger } from './utils/logger.utils'

globalStoreForLogging().startGlobalLog()
globalStoreForLogging().startLog('start-main')
Vue.use(VueIframe)

Vue.directive('hover-z', hoverZIndexDirective)

Vue.config.productionTip = false
Vue.config.devtools = isDevelopment

async function loadContext() {
  useCurrentUser()
  const state = useGlobalState()

  const { context, newRelicParameters } = await requestService.loadContext()
  state.context.value = context

  initNewRelic(newRelicParameters)
}

async function optimisedDependencieLoading() {
  const [{ router }, { vuetify }, { vueI18n }] = await Promise.all([
    import('./router/index'),
    import('./plugins/vuetify'),
    import('./plugins/i18n'),
    import('./plugins/teleport'),
  ])

  addRoutes(router, ALL_ROUTES)

  return {
    router,
    vuetify,
    vueI18n,
  }
}

loadContext()
  .then(async () => {
    const { router, vuetify, vueI18n } = await optimisedDependencieLoading()
    const apiKey = useGlobalState().context.value.raygunApiKey
    if (apiKey) {
      await setupRaygun(router, apiKey)
    }
    // eslint-disable-next-line unicorn/no-await-expression-member
    const App = (await import('./App.vue')).default as unknown as Component
    new Vue({
      router,
      vuetify,
      i18n: vueI18n,
      render: (h) => h(App),
    }).$mount('#app')
  })
  .catch((error) => {
    logger.error(error)
  })

globalStoreForLogging().endLog('start-main')
